import React from 'react';
import {
  NON_COOPERATION_REASON_OPTIONS,
  NonCooperationReasonCode,
} from '../constants/nonCooperationClosure';

interface NonCooperationReasonsFieldsetProps {
  selected: NonCooperationReasonCode[];
  onChange: (selected: NonCooperationReasonCode[]) => void;
}

const NonCooperationReasonsFieldset: React.FC<NonCooperationReasonsFieldsetProps> = ({
  selected,
  onChange,
}) => {
  const selectedSet = new Set(selected);

  const toggle = (code: NonCooperationReasonCode) => {
    onChange(
      selectedSet.has(code)
        ? selected.filter((selectedCode) => selectedCode !== code)
        : [...selected, code],
    );
  };

  return (
    <fieldset
      style={{
        border: '1px solid #f59e0b',
        borderRadius: '8px',
        padding: '12px',
        margin: '0 0 16px',
        backgroundColor: '#fffbeb',
      }}
    >
      <legend style={{ padding: '0 6px', fontWeight: 600, fontSize: '14px', color: '#92400e' }}>
        Outstanding client requirements
      </legend>
      <p style={{ margin: '0 0 10px', fontSize: '12px', color: '#92400e' }}>
        Select every reason that should appear in the client’s closure email.
      </p>
      <div style={{ display: 'grid', gap: '9px' }}>
        {NON_COOPERATION_REASON_OPTIONS.map(({ code, label }) => (
          <label
            key={code}
            style={{ display: 'flex', alignItems: 'flex-start', gap: '9px', fontSize: '13px', color: '#374151' }}
          >
            <input
              type="checkbox"
              checked={selectedSet.has(code)}
              onChange={() => toggle(code)}
              style={{ width: '16px', height: '16px', marginTop: '1px', flex: '0 0 auto' }}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};

export default NonCooperationReasonsFieldset;
